function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "lifebuoy",
  transform: "translate(-31.25 -31.25)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_42",
  "data-name": "Ellipse 42",
  cx: 10,
  cy: 10,
  r: 10,
  transform: "translate(32 32)",
  fill: "none",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_43",
  "data-name": "Ellipse 43",
  cx: 4.167,
  cy: 4.167,
  r: 4.167,
  transform: "translate(37.833 37.833)",
  fill: "none",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_31",
  "data-name": "Line 31",
  x1: 4.125,
  y1: 4.125,
  transform: "translate(34.929 34.929)",
  fill: "none",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_32",
  "data-name": "Line 32",
  y1: 4.125,
  x2: 4.125,
  transform: "translate(44.946 34.929)",
  fill: "none",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_33",
  "data-name": "Line 33",
  x2: 4.125,
  y2: 4.125,
  transform: "translate(44.946 44.946)",
  fill: "none",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_34",
  "data-name": "Line 34",
  x1: 4.125,
  y2: 4.125,
  transform: "translate(34.929 44.946)",
  fill: "none",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

function SvgActiveHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveHelp);
export default __webpack_public_path__ + "static/media/ActiveHelp.2f7a1adb.svg";
export { ForwardRef as ReactComponent };